export default {
  /* 신규 번역 */
  'u.header.exchange': '거래소',
  'u.header.myinvest': '투자상황',
  'u.header.wallet': '입출금',
  'u.header.mypage': '마이페이지',
  'u.header.cscenter': '고객센터',
  'u.header.login': '로그인',
  'u.header.logout': '로그아웃',
  'u.header.signup': '회원가입',
  'u.header.hello_message': '<span class="name">{name}</span>님, 환영합니다.',

  'u.login.login': '로그인',
  'u.login.email': '이메일',
  'u.login.password': '비밀번호',
  'u.login.check_exchange_address':
    '방문하신 거래소 주소가 아래와 같은지 확인해주세요.',
  'u.login.please_proceed_recaptcha': '아래 캡챠(CAPTCHA) 인증을 진행하세요.',
  'u.login.alert.please_enter_email': '이메일을 입력해주세요.',
  'u.login.alert.invalid_email': '잘못된 이메일 형식입니다.',
  'u.login.alert.please_enter_password': '비밀번호를 입력해주세요.',

  /* kycmodal */
  'u.mypage.kyc.passport': '여권',
  'u.mypage.kyc.id_card': '주민등록증',
  'u.mypage.kyc.driver_card': '운전면허증',
  'u.mypage.kyc.name': '이름',
  'u.mypage.kyc.first_name': '이름',
  'u.mypage.kyc.last_name': '성',
  'u.mypage.kyc.select': '선택',
  'u.mypage.kyc.mobile_number': '모바일 번호(- 없이)',
  'u.mypage.kyc.passport_number': '여권번호',
  'u.mypage.kyc.id_card_number': '주민등록번호 앞 6자리',
  'u.mypage.kyc.driver_card_number': '운전면허증 번호',
  'u.mypage.kyc.region': '국가/지역별 발행문서',
  'u.mypage.kyc.expire_date': '만료일',
  'u.mypage.kyc.issue_date': '발급일',
  'u.mypage.kyc.upload_image': '이미지 등록',
  'u.mypage.kyc.upload': '업로드',
  'u.mypage.kyc.modify': '수정',
  'u.mypage.kyc.delete': '삭제',
  'u.mypage.kyc.country': '국가',
  'u.mypage.kyc.city': '도시',
  'u.mypage.kyc.address': '주소',
  'u.mypage.kyc.postcode': '우편번호',
  'u.mypage.kyc.upload_image_example': '업로드 이미지 예제',
  'u.mypage.kyc.upload_image_example_description':
    '운전 면허증 앞 또는 귀하의 National ID Doucument를 선택하고 메모와 함께 업로드 할수 있습니다. 신분증을 들고있는 사진을 제공해주십시오. 같은 그림에서 {hostname}과 오늘 날짜가 표시 되어야 합니다. 얼굴이 선명하게 보이고 모든 신분증 카드 세부 사항을 명확하게 읽을 수 있어야 합니다.',
  'u.mypage.kyc.ok': '완료',
  'u.mypage.kyc.please_upload_file_size_below_5mb':
    '파일 사이즈를 5MB 이하로 업로드 해주세요.',
  'u.mypage.kyc.complete_message':
    'KYC 인증 신청이 완료 되었습니다.<br />KYC 인증 완료를 위해 시간이 2~4일 정도 소요 됩니다.<br /><br />인증이 완료되면 인증 센터에서 확인이 가능합니다.<br />감사합니다.',
  'u.mypage.kyc.please_hide_some_number':
    '인증사진 업로드 시 반드시 샘플 사진처럼 숫자의 일부를 가리고 보내 주세요!',

  /* register otp modal */
  'u.mypage.otp.email': '이메일',
  'u.mypage.otp.password': '비밀번호',
  'u.mypage.otp.otpcode': 'OTP 코드',
  'u.mypage.otp.otp_activate': 'OTP 활성화',
  'u.mypage.otp.i_check_about_otp': '확인하였습니다.',
  'u.mypage.otp.otp_warning_li1': '휴대폰으로 왼쪽 QR코드를 스캔해 주세요.',
  'u.mypage.otp.otp_warning_li2': '본 코드는 OTP를 초기화 하면 변경 됩니다.',
  'u.mypage.otp.otp_warning_li3': '본 QR코드를 휴대폰에서 삭제하시면 사용불가',
  'u.mypage.otp.alert.otp_warning_check': '주의사항을 읽고 확인해주세요.',
  'u.mypage.otp.alert.otp_activation_completed': 'OTP 설정이 완료되었습니다',

  /* error message */
  // [COMMON] ERROR CODE
  "api_error_code.-3000": "요청정보가 부족합니다.",
  "api_error_code.-3001": "정상적인 처리가 불가능한 상태입니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-3002": "데이터를 불러오는데 실패하였습니다.",
  "api_error_code.-3003": "이메일 발송에 실패했습니다. 관리자에게 문의 바랍니다.",
  // "api_error_code.-3004":"DB UPDATE ERROR [DANGER]",
  // "api_error_code.-3005":"DB DELETE ERROR [DANGER]",
  "api_error_code.-3006": "로그인에 실패하였습니다.",
  "api_error_code.-3007": "데이터를 불러오는데 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-3008": "회원정보 업데이트에 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-3009": "회원정보가 없습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-3100": "NODE 통신 에러",
  // "api_error_code.-3101":"임시점검",

  // [LOGIN] ERROR CODE
  "api_error_code.-3200": "접속회원 폭주로 인해 로그인을 잠시 중단합니다.",
  "api_error_code.-3201": "OTP 정보가 없습니다.",
  "api_error_code.-3202": "올바르지 않은 접근입니다.",
  "api_error_code.-3203": "로그인 후 이용 가능합니다.",
  "api_error_code.-3204": "로그인이 차단되었습니다. 고객센터({cs_tel})로 문의 바랍니다.",

  // [CAPTCHA] ERROR CODE
  "api_error_code.-3300": "로봇이 아님을 증명해 주시기 바랍니다.",
  "api_error_code.-3301": "로봇이 아님을 증명해 주시기 바랍니다.",

  // [EMAIL] ERROR CODE
  "api_error_code.-3400": "인증번호가 틀립니다. 인증번호를 확인해 주시기 바랍니다.",
  "api_error_code.-3700": "메일 인증에 실패 하였습니다.",
  "api_error_code.-3701": "메일 인증 후 DB 업데이트 실패",
  "api_error_code.-3702": "잘못된 요청입니다.",
  "api_error_code.-3703": "이메일 발송에 실패했습니다.",

  // [OTP] ERROR CODE
  "api_error_code.-3500": "QR코드 생성에 실패하였습니다.",
  "api_error_code.-3501": "구글 OTP 생성에 실패하였습니다.",
  "api_error_code.-3502": "구글 OTP 업데이트에 실패하였습니다.",
  "api_error_code.-3503": "구글 OTP 삭제에 실패하였습니다.",
  "api_error_code.-3504": "구글 OTP 생성 기록이 없습니다.",
  "api_error_code.-3505": "구글 OTP 정보를 불러오는데 실패하였습니다.",
  "api_error_code.-3506": "구글 OTP 키가 일치하지 않습니다.",
  "api_error_code.-3507": "구글 OTP 생성은 레벨3부터 신청 가능 합니다.",
  "api_error_code.-3508": "구글 OTP 코드를 입력해 주세요.",

  // [PASSWORD] ERROR CODE
  "api_error_code.-3600": "접근 불가능합니다.",
  "api_error_code.-3601": "유효시간이 만료되었습니다. 다시 요청바랍니다.",
  "api_error_code.-3602": "비밀번호가 일치하지 않습니다.",

  // [MEMBER] ERROR CODE
  "api_error_code.-3800": "등록된 회원이 존재하지 않습니다.",
  "api_error_code.-3801": "이미 가입된 회원입니다.",
  "api_error_code.-3802": "회원가입에 실패하였습니다.",
  "api_error_code.-3803": "회원정보가 일치하지 않습니다.",
  "api_error_code.-3804": "비밀번호가 일치하지 않습니다.",
  "api_error_code.-3805": "회원사 정보가 일치하지 않습니다.",
  "api_error_code.-3806": "회원정보 업데이트에 실패하였습니다.",
  "api_error_code.-3807": "지갑이 존재하지 않습니다.",
  "api_error_code.-3808": "계좌 등록에 실패하였습니다.",
  "api_error_code.-3809": "계좌 인증에 실패하였습니다.",
  "api_error_code.-3810": "관리자 승인 대기중입니다.",
  "api_error_code.-3811": "이미 관리자 승인 완료된 상태입니다.",
  "api_error_code.-3812": "출금한도 상향 신청에 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-3813": "이메일 인증을 완료해 주시기 바랍니다.",
  "api_error_code.-3814": "입력하신 아이디는 회원가입이 불가능합니다.",
  "api_error_code.-3815": "탈퇴된 아이디입니다.",

  // [KYC] ERROR CODE
  "api_error_code.-3900": "KYC 인증을 진행해 주시기 바랍니다.",
  "api_error_code.-3901": "현재 인증 대기 상태입니다.",
  "api_error_code.-3902": "KYC 인증 신청에 실패하였습니다.",
  "api_error_code.-3903": "이미지를 등록해 주십시오.",
  "api_error_code.-3904": "5M이하의 이미지 파일만 업로드 가능합니다.",
  "api_error_code.-3905": "파일 업로드를 실패하였습니다.",

  // [TRADE] ERROR CODE
  "api_error_code.-4000": "잘못된 요청입니다.",
  "api_error_code.-4001": "잘못된 요청입니다.",
  "api_error_code.-4002": "잘못된 요청입니다.",
  "api_error_code.-4003": "대기 주문 건은 최대 20건까지만 가능합니다.",
  "api_error_code.-4004": "최소 주문 금액은 {price}{market} 입니다.",
  "api_error_code.-4005": "호가 단위는 {priceUnit} 입니다. 호가단위를 확인바랍니다.",
  "api_error_code.-4006": "최소 주문 수량은 {amount}{symbol} 입니다.",
  "api_error_code.-4007": "자산이 부족합니다.",
  "api_error_code.-4008": "자산이 부족합니다.",
  "api_error_code.-4009": "주문 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4010": "주문 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4011": "주문 가격은 시장가의 50%로 제한됩니다.",
  "api_error_code.-4012": "주문 가격은 시장가의 50%로 제한됩니다.",
  "api_error_code.-4013": "잘못된 마켓 요청 입니다.",
  "api_error_code.-4014": "일시 정지된 마켓입니다.",
  // "api_error_code.-4015":"정지된 마켓",
  "api_error_code.-4016": "일시 매수가 정지되었습니다.",
  "api_error_code.-4017": "일시 매도가 정지되었습니다.",
  "api_error_code.-4018": "잘못된 요청 입니다.",
  "api_error_code.-4019": "이미 체결 완료되었습니다.",
  "api_error_code.-4020": "이미 주문 취소되었습니다.",
  "api_error_code.-4021": "주문 취소가 정상 처리되지 않았습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4022": "주문 취소가 정상 처리되지 않았습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4023": "현재 취소 처리가 진행 중입니다.",
  "api_error_code.-4024": "현재 체결이 진행 중입니다.",
  "api_error_code.-4025": "{symbol}의 최소 매수가격은 {price}{market} 입니다.",
  "api_error_code.-4026": "{symbol}의 최소 매도가격은 {price}{market} 입니다.",

  // [WALLET] ERROR CODE
  // "api_error_code.-4100":"환율이 변동되었습니다. 처음부터 다시 시도해 주시기 바랍니다.",
  // "api_error_code.-4101":"잘못된 요청입니다.",
  "api_error_code.-4102": "잘못된 요청입니다.",
  "api_error_code.-4103": "첫 입금 후 72시간 뒤에 출금 가능합니다.",
  // "api_error_code.-4104":"입금 최소 금액 10,000USDT 보다 작습니다.",
  // "api_error_code.-4105":"동일한 금액의 입금기록이 있습니다. 동일한 금액의 입금 요청은 24시간 이후부터 신청 가능합니다.",
  // "api_error_code.-4106":"입금 요청 등록에 실패 하였습니다.",
  "api_error_code.-4107": "일시적으로 출금이 제한되었습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4108": "지갑을 일시적으로 사용할 수 없습니다.",
  // "api_error_code.-4109":"로그정보가 등록되지 않았습니다.",
  // "api_error_code.-4110":"최소 출금 금액을 확인해 주시기바랍니다.",
  // "api_error_code.-4111":"1회 최대 출금 금액을 확인해 주시기바랍니다.",
  "api_error_code.-4112": "일일 최대 출금 {unit}을 확인해 주십시오.",
  "api_error_code.-4113": "잔고가 부족합니다.",
  "api_error_code.-4114": "출금 신청에 실패 하였습니다. 잠시 후 다시 시도해 주시기 바랍니다.",
  "api_error_code.-4115": "출금 신청에 실패 하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4116": "본인의 지갑 주소로 전송 하실 수 없습니다.",
  "api_error_code.-4117": "1회 최대 출금 가능한 수량은 {amount}{symbol} 입니다.",
  "api_error_code.-4118": "최소 주문 수량은 {amount}{symbol} 입니다.",
  "api_error_code.-4119": "올바른 주소가 아닙니다.",
  // "api_error_code.-4120":"KYC 인증을 진행해 주시기 바랍니다.",
  // "api_error_code.-4121":"출금 계좌 등록 후 출금신청이 가능합니다.",
  "api_error_code.-4122": "잘못된 요청 입니다.",
  "api_error_code.-4123": "회사 사정으로 지갑 생성을 중단합니다.",
  "api_error_code.-4124": "지갑 생성에 실패 하였습니다.",
  "api_error_code.-4125": "지갑 생성에 실패 하였습니다.",
  "api_error_code.-4126": "지갑을 일시적으로 사용할 수 없습니다.",
  "api_error_code.-4127": "일시적으로 출금 사용이 중지되었습니다.",
  "api_error_code.-4128": "데이터를 불러오는데 실패하였습니다.",
  // "api_error_code.-4129":"거래소 정보를 불러오는데 실패하였습니다.",
  "api_error_code.-4130": "데이터를 불러오는데 실패하였습니다.",
  "api_error_code.-4131": "주소 체크에 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4132": "전환 가능한 코인이 아닙니다.",
  "api_error_code.-4133": "잘못된 요청 입니다.",
  "api_error_code.-4134": "최소 전환 수량은 1USDT입니다.",
  "api_error_code.-4135": "전환가능한 코인 수량이 부족합니다.",
  "api_error_code.-4136": "전환 요청등록에 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4137": "전환 요청등록에 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4138": "전환 요청등록에 실패하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4139": "지갑생성 후 시도해주세요.",

  // [BALANCE] ERROR CODE
  "api_error_code.-4200": "자산정보를 불러오는데 실패하였습니다. 관리자에게 문의 바랍니다.",

  // [AIRDROP] ERROR CODE
  // "api_error_code.-4300":"로그인 유저의 airdrop 데이터 count query fail[메세지 노출안함]",
  // "api_error_code.-4301":"로그인 유저의 airdrop 데이터 list query fail[메세지 노출 안함]",
  // "api_error_code.-4302":"로그인 유저의 전일 거래량 데이터 count query fail[메세지 노출 안함]",
  // "api_error_code.-4303":"로그인 유저의 전일 거래량 데이터 list query fail[메세지 노출 안함]",
  // "api_error_code.-4304":"보유 수량 데이터 count query fail[메세지 노출 안함]",
  // "api_error_code.-4305":"보유 수량 데이터 list query fail[메세지 노출 안함]",
  // "api_error_code.-4306":"플랫폼 전일 총 거래금액 데이터 count query fail[메세지 노출 안함]",
  // "api_error_code.-4307":"플랫폼 전일 총 거래금액 데이터 list query fail[메세지 노출 안함]",
  // "api_error_code.-4308":"회원사 전일 총 거래금액 데이터 count query fail[메세지 노출 안함]",
  // "api_error_code.-4309":"회원사 전일 총 거래금액 데이터 list query fail[메세지 노출 안함]",
  // "api_error_code.-4310":"총 채굴량 데이터 count query fail[메세지 노출 안함]",
  // "api_error_code.-4311":"총 채굴량 데이터 list query fail[메세지 노출 안함]",
  // "api_error_code.-4312":"총 기여도 캐쉬 데이터 count query fail[메세지 노출 안함]",
  // "api_error_code.-4313":"총 기여도 캐쉬 데이터 list query fail[메세지 노출 안함]",

  // [SWAP] ERROR CODE
  "api_error_code.-4501": "신청 내역이 존재 합니다.",
  "api_error_code.-4502": "자산이 부족합니다.",
  "api_error_code.-4503": "신청에 실패 하였습니다. 관리자에게 문의 바랍니다.",
  "api_error_code.-4504": "신청내역이 없습니다.",
  "api_error_code.-4505": "이미 처리된 내역",

  /* 이전 번역 */
  hello: '안녕하세요',
  coin_search_placeholder: '코인명/심볼검색',
  coin_name: '코인명',
  coin_list_loading: '코인목록을 불러오고 있습니다.',
  there_is_no_coin: '마켓에 검색된 코인이 없습니다.',
  now_price: '현재가',
  compare_yesterday: '전일대비',
  trade_volume: '거래량(24H)',
  my_balances: '내 보유자산',
  holding_coin: '보유코인',
  total_balances_cash: '보유 CASH',
  total_balances: '총 보유자산',
  total_buying: '총매수',
  total_valuation: '총평가',
  profit_amount: '평가손익',
  profit_rate: '수익률',
  notice: '공지사항',
  notice_short: '공지',
  notice_loading: '공지사항을 불러오고 있습니다.',
  there_is_no_notice: '공지사항이 없습니다.',
  company: '회사소개',
  guide: '이용안내',
  terms: '이용약관',
  privacy: '개인정보처리방침',
  kakaotalk: '카카오톡 상담(24시간)',
  account_support: '계정, 사용 문의',
  wallet_support: '입출금, 기타 문의',
  'common.loading': '불러오는 중...',
  'common.please_login': '<span class="name">로그인</span> 후 이용해주세요.',
  'common.empty': '표시할 내용이 없습니다.',
  'common.million': '백만',
  'menu.exchange': '거래소',
  'menu.myinvest': '투자상황',
  'menu.wallet': '입출금',
  'menu.mypage': '마이페이지',
  'menu.cscenter': '고객센터',
  'menu.login': '로그인',
  'menu.logout': '로그아웃',
  'menu.signup': '회원가입',
  'menu.uio_announcement': '공시',
  'main.banner.phrase1': '새로워진 IEX GLOBAL을 만나보세요!',
  'main.banner.phrase2':
    'IEX GLOBAL EXCHANGE는 암호화폐 거래를 위한 최고의 사용자 UX를 제공합니다.',
  'main.banner.phrase3':
    '해외 IEX파트너로 중국, 태국, 베트남, 인도네시아 등<br />전 세계에서 거래소가 운영되는 세계 최초 글로벌 거래소입니다.',
  'main.notice': '공지사항',
  'main.is_logged_in': '님이 로그인하셨습니다.',
  'main.no_notice': '공지사항이 없습니다.',
  'main.uio_explain': '거래액에 따라 IEXCO 채굴코인 지급!',
  'main.contribute_cash_explain': '기여도에 따른 IEXCO 캐쉬 지급!',
  'main.cash_can_be_charged_with_platform':
    '제휴 플랫폼들의 캐쉬를 이용해 암호화폐 구입이 가능하며, 캐쉬는 제휴 플랫폼에서도 사용이 가능합니다.',
  'main.platform_point_to_cash': '제휴 플랫폼사에서 캐쉬로 전환',
  'main.uioex_wallet': '암호화폐 IEX WALLET',
  'main.uioex_exchange': 'IEX 암호화폐 거래소',
  'main.uioex_features': 'IEX 특징',
  'main.transparency': '투명성',
  'main.transparency_explain': '암호화폐 90% 이상은 콜드 스토리지에 보유',
  'main.cs24': '24시간 고객응대',
  'main.cs24_explain':
    '24시간 온라인 민원창구를 통해 이용에 문제되는 부분을 빠르게 해결해드립니다.',
  'main.security': '안전한 보안',
  'main.security_explain':
    '국내 최고의 보안업체 S1과 업무제휴를 통한 완벽한 보안성 금융기관 수준의 3중 보안 시스템',
  'main.giving_uio': 'IEXCO 코인지급',
  'main.giving_uio_explain': '거래소 거래실적에 따라 IEXCO코인이 보상됩니다.',
  'main.with_shoppingmall': '쇼핑몰 연동',
  'main.with_shoppingmall_explain':
    '보유 캐쉬는 보내기를 통해 제휴 플랫폼(쇼핑몰 등)에서 자유롭게 이용가능합니다.',
  'main.mobile_feature_title': '모바일 거래에 최적화된 서비스',
  'main.mobile_feature_01': '언제 어디에서나 거래가 가능한 모바일 전용 UI',
  'main.mobile_feature_02': '거래소 제휴 플랫폼 코인 지갑 주소의 휴대폰 번호화',
  'main.mobile_feature_03': '안드로이드, iOS 전용 APP 제공(오픈예정)',
  'main.go_to_exchange': '거래소 둘러보기',
  'main.cash_market': 'USDT마켓',
  'trade.order': '주문',
  'trade.orderbook': '호가',
  'trade.marketprice': '시세',
  'trade.chart': '차트',
  'trade.info': '정보',
  'trade.now_price': '현재가',
  'trade.evaluated_price': '평가금액',
  'trade.change': '변동률(%)',
  'trade.volume': '거래량',
  'trade.yesterday_last_price': '전일종가',
  'trade.today_high': '당일고가',
  'trade.today_low': '당일저가',
  'trade.volume_fiat': '거래대금',
  'trade.high': '고가',
  'trade.low': '저가',
  'trade.holding_coin': '보유코인',
  'trade.coin_name': '코인명',
  'trade.holding_amount': '보유수량',
  'trade.evaluted_price': '평가금액',
  'trade.coin_info': '코인정보',
  'trade.yesterday_contribution_cash': '전일 기여도 캐쉬',
  'trade.yesterday_contribution_cash_trade': '거래',
  'trade.yesterday_contribution_cash_not_trade': '미거래',
  'trade.paid_contribution_cash': '지급 기여도 캐쉬',
  'trade.person_count': '명',
  'trade.holding_uio_coin': '보유 IEXCO 코인(평균)',
  'trade.recommender_count': '추천인수',
  'trade.recommender_volume_fiat': '추천인 거래대금',
  'trade.type': '유형',
  'trade.gubun': '구분',
  'trade.time': '시간',
  'trade.ordered_time': '주문시간',
  'trade.price': '가격',
  'trade.amount': '수량',
  'trade.ordered_amount': '주문수량',
  'trade.ordered_price': '주문가격',
  'trade.cancel_select': '선택 주문 취소',
  'trade.outstanding_amount': '미체결량',
  'trade.confirmed_price_short': '체결가',
  'trade.confirmed_price': '체결가격',
  'trade.confirmed_amount': '체결량',
  'trade.confirmed_amount_cash': '체결금액',
  'trade.confirmed_time': '체결시각',
  'trade.status': '상태',
  'trade.all': '전체',
  'trade.confirming': '체결중',
  'trade.completed': '완료',
  'trade.cancel': '취소',
  'trade.buy': '매수',
  'trade.sell': '매도',
  'trade.realtime_trade_history': '실시간 체결',
  'trade.outstanding_order': '미체결',
  'trade.confirmed_order': '체결',
  'trade.order_amount': '주문량',
  'trade.orderbook_price': '호가',
  'trade.cancel_all': '일괄 취소',
  'trade.orderbook_left_amount_sum': '표시잔량합계',
  'trade.orderable': '주문가능',
  'trade.buy_amount': '매수수량',
  'trade.buy_price': '매수가격',
  'trade.sell_amount': '매도수량',
  'trade.sell_price': '매도가격',
  'trade.charge_cash': 'USDT충전',
  'trade.compare_with_now_price': '현재가 대비 %',
  'trade.total_order_price': '총 주문금액',
  'trade.max': '최대',
  'trade.can': '가능',
  'trade.order_unitPrice': '호가',
  'trade.min_order_amount_price': '최소주문금액',
  'trade.reset': '초기화',
  'trade.fee': '수수료',
  'trade.today_total_volume': '금일 총 거래액',
  'trade.yesterday_uio_mining': '전일 IEXCO 코인 채굴',
  'trade.today_minable_amount': '일 채굴량',
  'trade.today_minable_bonus_amount': '일 보너스 채굴량',
  'trade.total_volume': '총 거래 금액',
  'trade.my_volume': '본인 거래 금액',
  'trade.holding_uio_amount_avg': '보유 IEXCO 수량(평균)',
  'trade.mined_uio_amount': 'IEXCO 채굴량',
  'trade.recieved_bonus_uio_amount': '보너스 IEXCO 지급량',
  'trade.total_mined_uio_amount': '총 IEXCO 채굴량',
  'trade.there_is_no_outstanding_orders': '미체결 주문이 없습니다.',
  'trade.there_is_no_closed_orders': '체결된 주문이 없습니다.',
  'myinvest.funds': '자산내역',
  'myinvest.trade_history': '거래내역',
  'myinvest.outstanding_order': '미체결내역',
  'myinvest.wait_deposit_and_withdraw': '입출금대기',
  'myinvest.myinvest_info':
    '* 매수평균가, 평가금액, 평가손익, 수익률은 모두 CASH로 환산한 추정값으로 참고용입니다.',
  'myinvest.total_buy': '총 매수금액',
  'myinvest.total_evaluate': '총 평가금액',
  'myinvest.total_profit': '총 평가손익',
  'myinvest.total_profit_rate': '총 평가수익률',
  'myinvest.holding_cash': '보유 USDT',
  'myinvest.holding_total_assets': '총 보유 자산',
  'myinvest.holding_total_coin': '총 보유 코인',
  'myinvest.coin_name': '코인명',
  'myinvest.holding_amount': '보유수량',
  'myinvest.buy_unit_price_avg': '매수평균가',
  'myinvest.buy_price': '매수금액',
  'myinvest.evaluated_price': '평가금액',
  'myinvest.evaluated_profit_rate': '평가손익(%)',
  'myinvest.order': '주문',
  'myinvest.coin': '코인',
  'myinvest.confirmed_time': '체결시간',
  'myinvest.order_price': '주문가',
  'myinvest.confirmed_amount': '체결량',
  'myinvest.fee': '수수료',
  'myinvest.confirmed_price_avg': '체결가(평균)',
  'myinvest.confirmed_amount_price': '체결총액',
  'myinvest.7d': '7일',
  'myinvest.30d': '30일',
  'myinvest.90d': '90일',
  'myinvest.search': '조회',
  'myinvest.order_time': '주문시간',
  'myinvest.order_amount': '주문량',
  'myinvest.outstanding_amount': '미체결량',
  'myinvest.etc': '비고',
  'myinvest.time': '시간',
  'myinvest.amount': '금액/수량',
  'myinvest.platform': '플랫폼',
  'myinvest.deposit_name': '입금자명',
  'myinvest.status': '상태',
  'myinvest.go_to_block_explorer': '거래원장',
  'myinvest.txid': 'txid',
  'myinvest.deposit_wait': '입금대기',
  'mypage.member_info': '회원정보',
  'mypage.security': '보안인증',
  'mypage.connection_info': '접속정보',
  'mypage.contribution_cash_title': '기여도USDT 지급내역',
  'mypage.contribution_cash_title_short': '기여도USDT',
  'mypage.uio_mining': 'UNIEX코인 채굴내역',
  'mypage.uio_mining_short': '채굴내역',
  'mypage.recommender': '추천인',
  'mypage.change_password': '비밀번호 변경',
  'mypage.email': '이메일',
  'mypage.name': '이름',
  'mypage.phone': '휴대폰',
  'mypage.security_level': '보안등급',
  'mypage.your_trading_fee': '회원님의 거래수수료(부가세 포함)',
  'mypage.cash_markets': 'USDT마켓',
  'mypage.event_alram': '이벤트 등 안내(이메일, SMS) 수신',
  'mypage.event_alram_ok_or_deny': '이벤트 안내 수신 설정 / 거부',
  'mypage.event_alram_explain':
    '※ 입출금 안내 중요한 고지사항은 이벤트 안내 수신 동의 여부와 관계없이 이메일로 발송됩니다.',
  'mypage.password_condition': '영문소문자, 숫자, 특수문자 조합 8자 이상',
  'mypage.now_password': '현재 비밀번호',
  'mypage.new_password': '새 비밀번호',
  'mypage.new_password_check': '새 비밀번호 확인',
  'mypage.level': '레벨',
  'mypage.your_level':
    "<span class='name'>{name}</span>님의 현재 개인 보안등급은 <span class='level'>레벨 {level}</span>입니다.",
  'mypage.your_level_description':
    '현재 회원등급 [LV.{level}]로 바로 거래소 이용이 가능합니다.',
  'mypage.next_level_can_easy_deposit':
    '다음단계 입출금 계좌 인증으로 보다 편리한 입출금 서비스가 가능합니다.',
  'mypage.email_verification': '이메일 인증',
  'mypage.phone_verification': '휴대폰 본인인증',
  'mypage.bank_verification': '계좌인증',
  'mypage.otp_verification': 'OTP인증',
  'mypage.optional': '선택사항',
  'mypage.otp_app_desc':
    '스마트폰 (Android, iOS) Google Authenticator App을 설치해야 합니다.',
  'mypage.otp_is_optional': '* OTP 인증은 선택사항입니다.',
  'mypage.set': '설정',
  'mypage.request_reset': '초기화요청',
  'mypage.verify': '인증',
  'mypage.deposit_info': '입금전용 계좌 정보',
  'mypage.withdraw_info': '출금전용 계좌 정보',
  'mypage.bank_name': '은행명',
  'mypage.bank_account': '계좌번호',
  'mypage.bank_account_holder': '예금주',
  'mypage.deposit': '입금하기',
  'mypage.request_change_bank_account': '변경신청',
  'mypage.realname_account_check': '실명확인 입출금 서비스',
  'mypage.select_bank': '은행선택',
  'mypage.bank_account_placeholder': "'-'없이 숫자만 입력해주세요.",
  'mypage.not_this_bank': ' * 지역 농협, 축협 불가',
  'mypage.verify_my_account': '본인 계좌 인증',
  'mypage.otp_setting': 'OTP 설정',
  'mypage.otp_code_setting': 'OTP 코드 설정',
  'mypage.otp_with_login': '로그인 (로그인 시 OTP 인증 표시)',
  'mypage.otp_with_withdraw': '출금/송금 (자금 송금시 OTP 인증 표시)',
  'mypage.verification_code': '인증번호',
  'mypage.email_verification_code': '이메일 인증번호',
  'mypage.enter_number': '확인',
  'mypage.please_input_otp_verification_code': 'OTP 인증번호 입력',
  'mypage.save': '저장',
  'mypage.otp_setting_alert': '※ 설정 변경 시 체크박스를 해제 후 진행해주세요.',
  'mypage.otp_delete': 'OTP 설정 해제',
  'mypage.otp_delete_alert':
    '※ 설정 해제시 OTP 설정이 초기화되어 기존 OTP 사용이 불가하며 새로 OTP를 등록하셔야 합니다.',
  'mypage.connection_info_desc':
    '회원님의 로그인 이력입니다. 직접 로그인하지 않은 기록이 있다면, 즉시 비밀번호 변경 및 모든 디바이스에서 로그아웃해 주세요.',
  'mypage.location': '위치',
  'mypage.device': '기종',
  'mypage.browser': '브라우저',
  'mypage.ip': 'IP',
  'mypage.date': '일시',
  'mypage.contribution_cash_date': '날짜',
  'mypage.holding_coin': '보유코인',
  'mypage.holding_coin_state': '보유코인현황',
  'mypage.volume': '거래대금',
  'mypage.recommender_count': '추천인수',
  'mypage.recommender_volume': '추천인 거래금액',
  'mypage.contribution_cash': '기여도USDT',
  'mypage.day': '일',
  'mypage.month': '월',
  'mypage.year': '년',
  'mypage.accumulated_contribution_cash': '누적 기여도 캐쉬',
  'mypage.date_range': '기간',
  'mypage.search': '조회',
  'mypage.accumulated_uio_mining': '누적 채굴코인',
  'mypage.for_mining_volume': '액',
  'mypage.mined_amount': '채굴량',
  'mypage.bonus_uio_mined_amount': '보너스 IEXCO 지급량',
  'mypage.total_uio_mined_amount': '총 IEXCO 채굴량',
  'mypage.mined_unit_price': '채굴단가',
  'mypage.mined_uio': 'IEXCO 채굴량',
  'mypage.no': '번호',
  'mypage.recommend_date': '추천등록일',
  'mypage.more_withdraw_limit': '더 많은 출금한도',
  'support.notice': '공지사항',
  'support.guide': '이용안내',
  'support.faq': 'FAQ',
  'support.document_guide': '서류제출안내',
  'support.inquiry': '1:1문의',
  'support.notice_all': '전체',
  'support.notice_title': '제목',
  'support.notice_content': '내용',
  'support.notice_date': '등록일',
  'support.search': '조회',
  'support.no': '번호',
  'wallet.total_assets': '총 보유 자산',
  'wallet.cash_plus_coin': '(USDT+암호화폐 평가액)',
  'wallet.evaluated_coin': '암호화폐 평가액',
  'wallet.evaluated_profit': '평가손익',
  'wallet.evaluated_profit_rate': '수익률',
  'wallet.coin_name': '코인명',
  'wallet.holding_pie': '보유비중',
  'wallet.holding_amount': '보유수량(평가금액)',
  'wallet.holding_amount_short': '보유수량',
  'wallet.deposit_and_withdraw': '입출금',
  'wallet.total_cash': '총 보유 캐쉬',
  'wallet.on_trade_cash': '거래대기',
  'wallet.can_withdraw_cash': '출금가능',
  'wallet.accumulated_mining_coin': '누적 채굴 코인',
  'wallet.airdrop_lock': '에어드랍(Lock)',
  'wallet.evaluated_cash': 'CASH 평가금액',
  'wallet.cash_deposit': 'USDT입금',
  'wallet.cash_withdraw': 'USDT출금',
  'wallet.deposit': '입금',
  'wallet.withdraw': '출금',
  'wallet.cash_history': 'USDT 입출금내역',
  'wallet.charge_with_bank_account': '계좌 캐쉬 충전',
  'wallet.charge_with_platform': '제휴플랫폼 캐쉬 충전',
  'wallet.charge_with_bank_account_desc':
    '※ 아래 입금 금액 기입 후 "입금요청"을 먼저 하신 후에 무통장 입금을 당일(당일 24시)전에 입금 하셔야 합니다.',
  'wallet.deposit_amount': '입금금액',
  'wallet.deposit_amount_placeholder': '입금하실 금액을 입력해주세요',
  'wallet.won': '원',
  'wallet.deposit_name': '입금자',
  'wallet.request_deposit': '입금요청',
  'wallet.not_yet_verified':
    '아직 계좌인증을 받지 않아 계좌를 통한 캐쉬 충전이 불가능합니다. 계좌인증을 먼저 진행해주세요.',
  'wallet.not_yet_verified_withdraw':
    '아직 계좌인증을 받지 않아 계좌를 통한 캐쉬 출금이 불가능합니다. 계좌인증을 먼저 진행해주세요.',
  'wallet.cant_withdraw_now':
    '현재 출금이 불가능합니다. 자세한 내용은 공지사항을 참고해주세요.',
  'wallet.request_verify_bank_account': '계좌 인증하기',
  'wallet.select_platform': '제휴 플랫폼 선택',
  'wallet.tmoney': 'T-Money',
  'wallet.okcashbag': 'OK캐쉬백',
  'wallet.shopcorn': '샵콘',
  'wallet.please_use_shopcorn':
    '해당 플랫폼을 통한 캐쉬 충전은 준비중입니다. 샵콘을 이용해주세요.',
  'wallet.go_to_charge_with_platform': '충전',
  'wallet.charge_with_platform_desc':
    '※ 캐쉬 충전을 위해서는 제휴 사이트로 이동해 캐쉬 충전 후 거래소로 보내기를 해야 합니다.',
  'wallet.are_you_going_to_shopcorn':
    'www.shopcorn.co.kr 에서 충전이 가능합니다. 지금 바로 이동하시겠습니까?',
  'wallet.oneday_withdraw_limit': '1일 출금 한도',
  'wallet.min_withdraw_limit': '최소 출금가능',
  'wallet.onetime_withdraw_limit': '1회 출금 한도',
  'wallet.withdraw_to_bank_account': '은행 계좌 출금',
  'wallet.withdraw_to_platform': '제휴 플랫폼 출금',
  'wallet.can': '가능',
  'wallet.max': '최대',
  'wallet.request_withdraw_cash': '출금 요청 캐쉬',
  'wallet.can_use': '사용가능',
  'wallet.send_fee': '보내기 수수료',
  'wallet.please_enter_reciever_phone_num': '받는 분 휴대폰 번호 입력',
  'wallet.platform_withdraw_alert':
    '※ 제휴사 가입 시 사용한 전화번호와 일치해야 출금이 가능합니다.',
  'wallet.withdraw_bank_account_title': '출금 계좌 안내',
  'wallet.bank_name': '은행명',
  'wallet.bank_account': '계좌번호',
  'wallet.bank_account_holder': '예금주',
  'wallet.check_otp': 'OTP 확인',
  'wallet.hp_verification_for_your_safety':
    '안전한 출금을 위해 휴대폰 본인 인증을 한 번 더 합니다.',
  'wallet.please_enter_verification_code': '인증번호를 입력해주세요',
  'wallet.get_verification_code': '인증코드 받기',
  'wallet.check_verification_code': '인증코드 확인',
  'wallet.request_withdraw': '출금 신청하기',
  'wallet.request_withdraw_short': '출금 신청',
  'wallet.deposit_address': '입금주소',
  'wallet.deposit_withdraw_history': '입출금내역',
  'wallet.day': '{day}일',
  'wallet.1d': '1일',
  'wallet.7d': '7일',
  'wallet.30d': '30일',
  'wallet.60d': '60일',
  'wallet.all': '전체',
  'wallet.deposit_history': '입금내역',
  'wallet.withdraw_history': '출금내역',
  'wallet.depositWait_history': '입금대기내역',
  'wallet.airdrop_history': '지급내역',
  'wallet.airdropLock_history': '에어드랍(Lock)',
  'wallet.wait': '대기',
  'wallet.complete': '완료',
  'wallet.request_date': '요청일자',
  'wallet.deposit_cash': '입금 캐쉬',
  'wallet.platform_address': '제휴 사이트/계좌',
  'wallet.status': '상태',
  'wallet.withdraw_date': '출금일자',
  'wallet.withdraw_request': '출금요청',
  'wallet.withdraw_complete': '출금완료',
  'wallet.fee': '수수료',
  'wallet.reg_date': '등록일',
  'wallet.content': '내용',
  'wallet.airdrop_cash': '지급USDT',
  'wallet.my_deposit_address': '내 {coinName} 입금주소(입금전용)',
  'wallet.new_member_must_create_address':
    '신규 가입하신 회원님께서는 주소 생성하기 버튼을 클릭하셔야 고유 {coinName} 주소가 발급됩니다.',
  'wallet.deposit_alert': '입금 시 주의사항',
  'wallet.you_can_check_last_deposit_withdraw_history_in_history_menu':
    '※ 과거 입출금 내역은 거래 내역현황 페이지에서 확인 가능합니다.',
  'wallet.withdraw_fee_desc':
    '출금수수료는 건당 100USDT씩 부과됩니다. 1,000 USDT 신청시 수수료 100 USDT가 차감되어 등록계좌로 900USDT가 입금됩니다.',
  'wallet.copy': '복사',
  'wallet.withdraw_amount': '출금수량',
  'wallet.to_external_address': '지갑 주소로 보내기',
  'wallet.to_internal_member': '휴대폰 번호로 보내기(내부회원)',
  'wallet.check_coin_address': '출금주소체크',
  'wallet.withdraw_fee': '출금 수수료 (부가세 포함)',
  'wallet.total_withdraw_amount': '총 출금(수수료 포함)',
  'wallet.withdraw_alert': '출금 시 주의사항',
  'footer.link_about_company': '회사소개',
  'footer.link_notice': '공지사항',
  'footer.link_terms': '이용약관',
  'footer.link_privacy': '개인정보처리방침',
  'footer.link_guide': '이용안내',
  'footer.link_faq': 'FAQ',
  'footer.copyright_line1':
    '대표 : 민서준 사업자등록번호. 678-88-00932 통신판매업신고 : 제2018-서울강남-00897',
  'footer.copyright_line2': '서울시 강남구 테헤란로 14길 16 (주)씨비아이플랫폼',
  'footer.cs_account': '계정.사용문의',
  'footer.cs_pay': '입출금, 기타문의',
  'footer.cs_time':
    '고객센터 응답시간 : 09:30 ~ 17:30 (점심시간 12:00 ~ 13:00) 당사는 유선상담 및 방문상담을 진행하지 않습니다.',
  'footer.cs_kakaotalk': '카카오톡 24시간 상담',
  'account.find_id': '아이디 찾기',
  'account.find_pw': '비밀번호 찾기',
  'account.email': '이메일',
  'account.username': '이름',
  'account.password': '비밀번호',
  'account.confirm': '비밀번호 확인',
  'account.recommender': '추천인',
  'common.next': '다음',
  'alert.please_enter_email': '이메일을 입력해주세요.',
  'alert.invalid_email': '잘못된 이메일 형식입니다.',
  'alert.please_enter_password': '비밀번호를 입력해주세요.',
  'uio_announce.yesterday_announcement': '전일 공시',
  'uio_announce.original_mining': '정량채굴코인',
  'uio_announce.level_mining': '레벨채굴코인',
  'uio_announce.daterange_mining': '보유기간 채굴코인',
  'mypage.your_level_description_cant':
    "현재 회원등급 <span className='text-primary'>[레벨 {level}]</span>로 거래소 이용이 불가능합니다.",
  /* 번역 추가본 19.04.01 */
  'trade.iex_announce.platform_volume': '플랫폼 거래금액',
  'trade.iex_announce.partner_volume': '회원사 거래금액',
  'trade.iex_announce.holding_iex_amount': '보유 IEXCO 수량',
  'trade.iex_announce.total_mining_amount': '전일 내 채굴량',
  'trade.iex_announce.total_iex_contribution_cash': '전일 내 기여도 캐쉬',
  'alert.market_comming_soon': '{market}마켓 준비중입니다.',
  'alert.login_success': '반갑습니다. UNIONEX에 오신 것을 환영합니다.',
  'alert.login_failed': '로그인에 실패했습니다. 다시 시도해주세요.',
  'alert.sended_findpw_email':
    '이메일로 임시 비밀번호와 링크가 전송되었습니다. 이메일을 확인해주세요.',
  'alert.api_error': '서버와의 통신 중 오류가 발생했습니다. 다시 시도해주세요.',
  'findpw.title': '비밀번호 찾기',
  'findpw.info_message': '등록된 이메일 주소로 임시 비밀번호가 전송됩니다.',
  'findpw.change_pw': '비밀번호 변경',
  'signin.info_message':
    '고객님의 소중한 정보 보호를 위해 거래소 주소가 아래 주소와 같은지 확인해 주세요.',
  'signup.agree_to_terms': '이용약관 동의',
  'signup.agree_to_privacy_policy': '개인정보처리방침 동의',
  'signup.please_agree_to_terms': '이용약관에 동의해주세요.',
  'signup.please_agree_to_privacy_policy': '개인정보처리방침에 동의해주세요.',
  'signup.alert.please_enter_email': '이메일을 입력해주세요.',
  'signup.alert.invalid_email': '이메일 형식이 맞지 않습니다.',
  'signup.alert.please_proceed_email_verification':
    '이메일 인증을 진행해주세요.',
  'signup.alert.please_enter_name': '이름을 입력해주세요.',
  'signup.alert.please_enter_email_verification_code':
    '이메일 인증번호를 입력해주세요.',
  'signup.alert.please_enter_password': '비밀번호를 입력해주세요.',
  'signup.alert.please_enter_password_check': '비밀번호 확인을 입력해주세요.',
  'signup.alert.pw_validation_length': '비밀번호는 8자리 이상이어야 합니다.',
  'signup.alert.pw_validation_combination':
    '비밀번호는 영문, 숫자, 특수문자를 모두 포함해야 합니다.',
  'signup.alert.pw_and_pwcheck_not_same':
    '비밀번호와 비밀번호 확인이 일치하지 않습니다.',
  'signup.alert.please_check_google_recaptcha': '로봇이 아닌지 증명해주세요.',
  'signup.alert.signup_success': '회원가입이 완료되었습니다.',
  'signup.alert.please_check_email_verification_code':
    '이메일 인증번호가 전송되었습니다. 확인 후 인증번호를 입력해주세요.',
  'signup.alert.email_verification_time_expired':
    '이메일 인증 시간이 만료되었습니다. 다시 이메일 인증번호를 요청하신 후 인증을 진행해주세요.',
  'signup.alert.email_verification_success':
    '이메일 인증번호 확인이 완료되었습니다.',
  'signup.alert.email_verification_code_is_not_matching':
    '인증번호가 틀립니다. 다시 확인 후 입력해주세요.',
  'wallet.history.request_date': '요청일자',
  'wallet.history.deposit_name': '입금자명',
  'wallet.history.deposit_cash': '충전 USDT',
  'wallet.history.deposit_fiat': '입금액',
  'wallet.history.account': '제휴 사이트/계좌',
  'wallet.history.status': '상태',
  'wallet.history.withdraw_date': '출금일자',
  'wallet.history.withdraw_request': '출금요청',
  'wallet.history.withdraw_is_complete': '출금완료',
  'wallet.history.withdraw_fee': '수수료',
  'wallet.history.withdraw_status': '상태',
  'wallet.history.reg_date': '등록일',
  'wallet.history.content': '내용',
  'wallet.history.airdrop_cash': '지급USDT',
  'wallet.history.airdrop_coin': '지급코인',
  'wallet.history.txid_link': '거래원장',
  'wallet.history.amount': '수량',
  'wallet.deposit_below_address': '아래 주소로 {coin_name} 입금해주세요.',
  'wallet.generate_deposit_address': '{coinName} 주소 생성하기',
  'wallet.deposit_in_maintenance':
    '현재 {coin_symbol} 입금이 점검중입니다. 잠시 후 이용해주세요.',
  'wallet.withdraw_from_exchange_wallet_to_your_wallet':
    '거래소 지갑으로부터 회원님의 외부 {coin_name} 지갑으로 {coin_name_josa} 출금합니다. 모든 출금은 관리자 확인 후 출금됩니다.',
  'wallet.i_agree_to_withdraw_warning':
    '출금안내 및 주의사항을 읽고 동의합니다.',
  'wallet.withdraw_address': '출금주소',
  'wallet.withdraw_under_maintanance':
    '현재 {coin_symbol} 출금이 점검중입니다. 잠시 후 이용해주세요.',
  'trade.market_under_maintance':
    '현재 {market} 마켓이 점검중입니다. 잠시 후 이용해주세요.',
  'mypage.not_verified': '미인증',
  'mypage.verification_is_processing': '인증 진행중...',
  'mypage.refuse_verification': '인증 거부됨',
  'trade.alert.invalid_amount_price': `주문수량과 주문금액을 올바르게 입력해주세요.`,
  'trade.alert.invalid_order_unit_price': `호가 단위가 일치 하지 않습니다.`,
  'trade.alert.invalid_min_cash': `최소 주문 가능 CASH는 {cash}CASH입니다.`,
  'trade.alert.invalid_orderable_amount': `주문가능금액이 부족합니다.`,
  'trade.alert.success_request_cancel_order':
    '미체결 주문 취소를 요청 하였습니다.',
  /* 19.04.10 */
  'mypage.verified': '인증',
  'mypage.kyc_verification': 'KYC 인증',
  'mypage.kyc.verification_type': '식별 유형',
  'mypage.kyc.passport': '여권',
  'mypage.kyc.id_card': '주민등록증',
  'mypage.kyc.driver_card': '운전면허증',
  'mypage.kyc.name': '이름',
  'mypage.kyc.first_name': '이름',
  'mypage.kyc.last_name': '성',
  'mypage.kyc.select': '선택',
  'mypage.kyc.mobile_number': '모바일 번호(- 없이)',
  'mypage.kyc.passport_number': '여권번호',
  'mypage.kyc.id_card_number': '주민등록번호 앞 6자리',
  'mypage.kyc.driver_card_number': '운전면허증 번호',
  'mypage.kyc.region': '국가/지역별 발행문서',
  'mypage.kyc.expire_date': '만료일',
  'mypage.kyc.issue_date': '발급일',
  'mypage.kyc.upload_image': '이미지 등록',
  'mypage.kyc.upload': '업로드',
  'mypage.kyc.modify': '수정',
  'mypage.kyc.delete': '삭제',
  'mypage.kyc.country': '국가',
  'mypage.kyc.city': '도시',
  'mypage.kyc.address': '주소',
  'mypage.kyc.postcode': '우편번호',
  'mypage.kyc.upload_image_example': '업로드 이미지 예제',
  'mypage.kyc.upload_image_example_description':
    '운전 면허증 앞 또는 귀하의 National ID Doucument를 선택하고 메모와 함께 업로드 할수 있습니다. 신분증을 들고있는 사진을 제공해주십시오. 같은 그림에서 {hostname}과 오늘 날짜가 표시 되어야 합니다. 얼굴이 선명하게 보이고 모든 신분증 카드 세부 사항을 명확하게 읽을 수 있어야 합니다.',
  'mypage.kyc.ok': '완료',
  'wallet.first_create_deposit_address':
    '입금주소 탭에서 코인 지갑 주소 생성후 출금해 주세요.',
  'mainbanner.buy': '구매',
  'mypage.kyc.please_upload_file_size_below_5mb':
    '파일 사이즈를 5MB 이하로 업로드 해주세요.',
  'kyc.complete_message':
    'KYC 인증 신청이 완료 되었습니다.<br />KYC 인증 완료를 위해 시간이 2~4일 정도 소요 됩니다.<br /><br />인증이 완료되면 인증 센터에서 확인이 가능합니다.<br />감사합니다.',
  'alert.change_password_completed':
    '비밀번호 변경이 완료되었습니다. 새 비밀번호로 로그인해주세요.',
  'alert.please_enter_temp_password': '임시비밀번호를 입력해주세요.',
  'mypage.temp_password': '임시 비밀번호',
  'alert.otp_check_completed': 'OTP 확인이 완료되었습니다.',
  'alert.withdraw_request_is_completed': '계좌 출금 요청이 완료되었습니다.',
  'trade.alert.not_match_amount_and_price':
    '주문수량과 주문금액을 올바르게 입력해주세요.',
  'trade.alert.not_match_unit_price': '호가단위가 일치하지 않습니다. 호가단위는 {unitPrice}입니다.',
  'trade.alert.min_orderable_cash_error':
    '최소 주문 가능 {market_type}는 {min_orderable_cash}{market_type}입니다.',
  'trade.alert.max_orderable_cash_error':
    '최대 주문 가능 {market_type}는 {max_orderable_cash}{market_type}입니다.',
  'trade.alert.run_out_of_cash': '주문가능금액이 부족합니다.',
  'trade.alert.market_is_under_maintanance':
    '현재 {market} 마켓이 점검중입니다. 잠시 후 이용해주세요.',
  'trade.confirm_order': '주문확인',
  'alert.market_is_preparing': '{market}마켓 준비중입니다.',
  'alert.cancel_order_completed': '요청하신 미체결 주문 취소가 완료되었습니다.',
  'alert.cancel_order_requested': '미체결 주문취소 요청이 완료되었습니다.',
  'alert.please_enter_address_to_check': '확인할 주소를 입력해주세요.',
  'alert.checking_address_is_completed': '출금주소 확인이 완료되었습니다.',
  'alert.please_deposit_cash':
    '캐쉬 입금 요청이 완료되었습니다. 해당 계좌로 입금해주세요.',
  'wallet.please_deposit_cash_desc':
    '입금요청하신 <span class="deposit-money">{deposit_amount}</span> {currency}을 아래 계좌로 입금해주시기 바랍니다.',
  'wallet.deposit_warning_title': '입금 요청 시 유의사항',
  'wallet.deposit_warning_li1':
    '입금 신청 후 당일 자정(24시) 이내에 입금하셔야 합니다.',
  'wallet.deposit_warning_li2':
    '당일 24시를 넘겨서 입금하실 경우 해당 날짜에 맞추어 입금요청을 새로 넣으셔야 합니다.',
  'wallet.deposit_warning_li3':
    '동일한 금액을 두 번 연속 신청하실 수 없습니다.',
  'wallet.deposit_warning_li4':
    '입금계좌번호와 은행을 확인하시고 입금해주시기 바랍니다.',
  'mypage.otp_activate': 'OTP 활성화',
  'mypage.i_check_about_otp': '확인하였습니다.',
  'mypage.otp_warning_li1': '휴대폰으로 왼쪽 QR코드를 스캔해 주세요.',
  'mypage.otp_warning_li2': '본 코드는 OTP를 초기화 하면 변경 됩니다.',
  'mypage.otp_warning_li3': '본 QR코드를 휴대폰에서 삭제하시면 사용불가',
  'mypage.alert.otp_warning_check': '주의사항을 읽고 확인해주세요.',
  'mypage.alert.otp_activation_completed': 'OTP 설정이 완료되었습니다',
  'wallet.deposit_account_registration': '입출금 계좌 등록',
  'mypage.complete_registration_deposit_account':
    '입출금 계좌 등록이 완료되었습니다.',
  'alert.otp_delete_completed': 'OTP 설정 해제가 완료되었습니다.',
  'alert.otp_setting_updated': 'OTP 설정이 업데이트 되었습니다.',
  'signup.alert.password_change_completed':
    '비밀번호가 성공적으로 변경되었습니다.',
  'signup.alert.password_change_failed': '비밀번호 변경에 실패했습니다.',
  'signin.please_enter_otp_6': 'OTP 인증번호 6자리를 입력하세요.',
  'alert.deposit_address_copied': '입금주소가 복사되었습니다.',
  'mypage.cryptocurrency': '암호화폐',
  'mypage.authentication_type': '인증방법',
  'mypage.deposit_limit': '입금한도',
  'mypage.withdrawal_limit': '출금한도',
  'mypage.unlimited': '무제한',
  'mypage.once': '1회',
  'mypage.by_oneday': '1일',
  'guide.main_title': '이용안내',
  'guide.platform_title': '플랫폼 운영정책',
  'guide.trade_title': '코인거래 이용안내',
  'guide.cash_market': 'USDT마켓',
  'guide.market_gubun': '마켓구분',
  'guide.gubun': '구분',
  'guide.content': '내용',
  'guide.cash_market_desc': 'USDT로 암호화폐를 사고 팔 수 있습니다.',
  'guide.day_trade_data_standard': '일별 거래 데이터 기준',
  'guide.day_trade_data_standard_desc':
    'UTC(협정세계시)를 기준으로 일별 데이터를 계산합니다. 대다수의 글로벌 거래소들이 UTC 기준 시간을 사용하고 있어 해외 시세 비교에 용이한 장점이 있습니다. UTC는 한국시간(KST)보다 9시간 느립니다.',
  'guide.updown_yesterday': '전일 대비 등락률',
  'guide.updown_yesterday_desc':
    'UTC 기준 0시(한국시간 오전 9시) 종가 대비 당일 종가 (혹은 현재가) 등락률',
  'guide.trade_volume': '거래량(24H)',
  'guide.trade_volume_desc': '최근 24시간 동안의 누적 거래량',
  'guide.candle_day': '캔들차트 일봉',
  'guide.candle_day_desc':
    'UTC 기준 0시부터 24시간(혹은 현재시점) 동안의 시가/고가/저가/종가',
  'guide.trade_fee_standard': '거래 수수료 기준',
  'guide.trade_fee_standard_desc1':
    '거래수수료 계산방식 : 체결금액 (주문수량 X 주문가격) X 거래수수료율(%)',
  'guide.trade_fee_standard_desc2':
    '거래수수료는 소수점 둘째 자리까지 표시됩니다.',
  'guide.trade_fee_method': '거래수수료 정산방식',
  'guide.trade_fee_method_desc1':
    '매수 주문 시 정산금액 = 체결금액 (주문수량 X 주문가격) + 거래수수료',
  'guide.trade_fee_method_desc2':
    '매도 주문 시 정산금액 = 체결금액 (주문수량 X 주문가격) – 거래수수료',
  'guide.min_orderable_price_and_unit_price': '최소주문단위 및 호가단위',
  'guide.min_orderable_price': '최소주문단위',
  'guide.unit_price': '호가단위',
  'guide.deposit_fee': '입금수수료',
  'guide.withdrawal_fee': '출금수수료',
  'guide.no_charge': '무료',
  'guide.dw_support_title': '입출금 지원화폐',
  'guide.level_guide_title': '입,출금 지원 화폐 및 고객(회원)의 보안등급별 입,출금 한도',
  'guide.dw_fee_guide_title': '코인별 입,출금 수수료',
  'guide.dw_fee_guide_desc1':
    '캐쉬(CASH) 전환 후 메뉴 플랫폼으로 이동하여 환전 또는 사용이 가능합니다. ',
  'guide.dw_fee_guide_desc2':
    '위 수수료 정책은 이용약관 25조에 의거하여 시장상황에 따라 예고없이 변동 될 수 있음을 알려드립니다.',
  'guide.unionex_mining_title': '거래금액에 따른 채굴',
  'guide.mining_range': '채굴구간',
  'guide.mining_coin_cnt': '발행코인 수',
  'guide.mining_volume': '거래금액',
  'socket_api_code.202': '{od_temp_coin} {currency} 매도 주문 완료',
  'socket_api_code.204': '{od_temp_coin} {currency} 매수 주문 완료',
  'socket_api_code.206': '{currency} 매도 주문 취소 처리 되었습니다. ',
  'socket_api_code.208': '{currency} 매수 주문 취소 처리 되었습니다.',
  'socket_api_code.210': '{currency} {od_temp_coin} 개가 체결되었습니다.',
  'otp.remove': '해제',
  'otp.verification_pending': '인증대기중...',
  'home.m.title': '모바일 거래에 최적화된 서비스',
  'home.m.desc': '언제 어디에서나 거래가 가능한 모바일 전용 UI',
  'home.about.t1': '보안 제일주의',
  'home.about.d1':
    '<li>해킹등에 대비한 완벽한 보안시스템 구축</li><li>Cold storage 방법 적용</li><li>24시간 코인 입 출금 모니터링 시행',
  'home.about.t2': '공유경제 플랫폼',
  'home.about.d2':
    '<li>플랫폼의 수익(거래수수료)은 파트너스 및 User와 공유</li><li>분배</li><li>파트너스 및 User와의 원활한 소통 실천',
  'home.about.t3': '독자 기술 플랫폼',
  'home.about.d3':
    '<li>다년간 축적된 거래소 운영 노하우 보유</li><li>독자 기술로 개발한 플랫폼',
  'home.about.t4': '투명 경영 실천',
  'home.about.d4':
    '<li>소유와 경영의 분리</li><li>제반 경영 데이터 공개',
  'security.your_level.lv1':
    '현재 회원등급[LV1] 바로 거래소 이용이 가능 합니다. 다음단계 KYC 인증을 통해 본인 인증과 코인 출금을 활성화 해주십시오!',
  'security.your_level.lv2':
    '현재 회원등급[LV2] 본인 인증이 완료 되었습니다. 다음단계 OTP인증을 통해 보안을 강화하고 더 많은 코인 입출금이 가능합니다.',
  'security.your_level.lv3':
    '현재 회원등급[LV3] OTP 인증이 완료 되었습니다.',
  'security.your_level.lv4':
    '현재 회원등급[LV4] 더 많은 출금한도 요청이 완료 되었습니다.',
  'security.level4.desc':
    '상향요청하시면 본인 거래실적 및 기여도에 따라 관리자가 레벨을 상향조정합니다.',
  'security.level4.request': '출금한도 상향 요청',
  'security.level4.pending': '처리중...',
  'security.level4.desc_success':
    '요청하신 출금한도 상향 요청이 승인 되었습니다.',
  'security.level4.desc_failed':
    '요청하신 출금한도 상향 요청이 거절 되었습니다. 더 많은 거래 실적이 필요 합니다.',
  'alert.request_lv4_success':
    '출금한도 상향요청에 성공했습니다. 관리자 확인까지 기다려주세요.',
  'coinInfo.summary': '개요',
  'coinInfo.about': '코인 소개',
  'alert.bank_verification.no_kyc': 'KYC 인증 후에 사용이 가능합니다.',
  'alert.do_you_want_to_log_out': '로그아웃하시겠습니까?',
  'wallet.minimum_withdraw_amount': '최소 출금금액',
  'wallet.withdraw_account_info': '출금계좌 안내',
  'trade.favorite': '즐겨찾기',
  'required': '필수',
  'all_is_required': '모든 항목은 필수 입력 사항입니다.',
  'alert.you_can_search_max_three_month': '최대 3개월까지 조회 가능합니다.',
  'trade.hours': '시간',
  'myinvest.you_have_no_coin': '보유코인이 없습니다.',
  'wallet.history.od_status.CAN': '취소',
  'wallet.history.od_status.OK': '완료',
  'wallet.history.od_status.REQ': '요청',
  'wallet.history.od_status.WAIT': '대기',
  'wallet.history.od_status.REJ': '거부',
  'wallet.history.od_status.HOLD': '중지',
  'wallet.history.od_status.PROC': '처리중',
  'alert.please_verify_otp_code': 'OTP인증을 진행해주세요.',
  'alert.min_deposit_up_is': '※ 최소 입금가능금액은 {min_deposit}USDT입니다.',
  'alert.min_deposit_usdt': '최소 입금 USDT',
  'notice.hq': '전체공지',
  'bankaccount.desc': '출금전용 계좌는 은행 구분없이 본인명의의 계좌 1개만 등록가능합니다.',
  'wallet.convert': '전환',
  'wallet.convert_coin': '전환코인',
  'wallet.convert_history': '전환내역',
  'wallet.convertable_coin': '전환 가능 코인',
  'wallet.lets_convert_coin': '코인 USDT 코인으로 전환',
  'wallet.alert.only_btc_and_eth_is_convertable': '※ BTC, ETH코인만 USDT코인으로 전환할 수 있습니다.',
  'wallet.convert_amount': '전환수량',
  'wallet.usdt_amount': 'USDT 수량',
  'wallet.select_coin': '코인 선택',
  'wallet.request_convert': '전환하기',
  'wallet.check_below_before_convert_usdt': '아래와 같이 코인을 전환하시겠습니까?',
  'wallet.coin_convert_done': '코인 전환이 완료되었습니다.',
  'alert.first_login': '사전가입이 완료 되었습니다. 모의투자를 위한  8,000 USDT는 대회 기간에 로그인하시면 확인 가능합니다.',
  'kyc.rejected': 'KYC인증이 거절 되었습니다. 다시 진행해 주세요!',
  'trade.today_volume': '금일 총거래대금',
  'trade.yesterday_volume': '전일 총거래대금',
  'kyc.rejected_type_0': 'KYC인증이 거절 되었습니다. 다시 진행해 주세요!',
  'kyc.rejected_type_1': '신분증을 들고 찍은 사진을 올려주세요.',
  'kyc.rejected_type_2': '신분증 내용 확인 불가능합니다.',
  'kyc.rejected_type_3': '성함에서 “성” 과 “이름”을 구별해 입력해 주세요',
  'kyc.rejected_type_4': '기타 – 고객센터에 문의 해 주세요!',
  'kyc.rejected_type_5': '메모 내용이 누락되었거나 정확하지 않습니다. (내용 : URL, 오늘 날짜)',
  'kyc.check_rejected_msg': '거절사유 보기',
  'wallet.history.airdrop_date': '에어드랍 지급일',
  'wallet.history.airdrop_type': '지급 구분',
  'wallet.history.airdrop_amount': '전체 지급 수량(LOCK)',
  'wallet.history.airdrop_release_lock': 'LOCK 해제 시각',
  'wallet.history.airdrop_release_lock_period': 'LOCK 해제 주기',
  'wallet.history.airdrop_release_lock_amount': 'LOCK 해제 수량',
  'wallet.history.is_mining': '채굴',
  'wallet.alert.convert_price_is_on_cmc': '※ USDT전환시 기준시세는 CoinMarketCap을 기준으로 합니다.',
  'home.about.guide.platform.title': "운영정책",
  'home.about.guide.platform.desc': `<li>개요</li>
  <li>UNIEX 플랫폼 코인</li>
  <li>수익의 분배</li>
  <li>고객 입, 출금 절차</li>
  <li>입출금 지원 화폐 및 보안등급별 입,출금 한도</li>`,
  'home.about.guide.trade.title': "거래이용안내",
  'home.about.guide.trade.desc': `<li>마켓구분</li>
  <li>일별 거래 데이터의 기준</li>
  <li>수수료의 계산 및 정산 기준</li>
  <li>최소 주문 및 호가단위</li>
  <li>코인별 입출금 수수료</li>`,
  'home.about.guide.download.title': "다운로드",
  'home.about.guide.download.warning_for_investor': "투자자 유의사항",
  'home.about.guide.download.fraud_guide': "금융사기 주의안내",
  'home.about.guide.download.deposit_error': "코인 오입금 처리안내",
  'wallet.withdraw_dest_tag': '데스티네이션 태그',
  'wallet.my_deposit_dest_tag': '내 데스티네이션 태그',
  'alert.deposit_dest_tag_copied': '데스티네이션 태그가 복사되었습니다.',
  'wallet.staking_history': '스테이킹내역',
  'wallet.history.coin_amount': "코인수량",
  'wallet.history.release_staking_start_date': "스테이킹 시작일",
  'wallet.history.release_staking_end_date': "스테이킹 해제일",
  'mypage.cancel_account': '회원탈퇴',
  'mypage.cancel_account.step1.title': '회원탈퇴안내',
  'mypage.cancel_account.step1.desc': '회원탈퇴 시 주의사항을 확인해 주세요',
  'mypage.cancel_account.step2.title': '보유자산 확인',
  'mypage.cancel_account.step2.desc': '보유자산을 확인하시고 출금을 진행해 주세요',
  'mypage.cancel_account.step3.title': '회원탈퇴 신청서',
  'mypage.cancel_account.step3.desc': '회원탈퇴와 관련된 사항을 해당 폼에 맞게 작성해 주세요',
  'mypage.cancel_account.step4.title': '회원탈퇴 신청 완료',
  'mypage.cancel_account.step4.desc': '회원탈퇴 신청이 완료되었습니다. 자료 확인을 거쳐 완료처리됩니다.',
  'mypage.cancel_account.step1.body_title': '회원탈퇴 주의사항 안내',
  'mypage.cancel_account.step1.body_desc': '보유자산이 남아있다면 출금 후 회원탈퇴를 진행해 주세요.<br />탈퇴 진행 시 보유하신 자산 정보가 삭제되어 복구가 불가능합니다.<br />회원탈퇴 시 거래소에 등록된 회원님의 개인정보는 모두 삭제되며 복구되지 않습니다.<br />단, 관계법령에 따라 회사가 보관하여야 하는 정보는 일정 기간 보관됩니다.<br /><br /회원탈퇴 후에는 고객님의 USDT, 암호화폐 정보가 모두 파기되기 때문에 이후에 진행되는 모든 에어드랍은 받을 수 없습니다. <br />회원탈퇴 후에는 거래소 계정으로 연동되는 외부 서비스 역시 모두 이용할 수 없게 되며, 이와 관련된 연결 기록 등을 복구할 수 없습니다.<br />탈퇴 전 이 모든 사항들을 꼭 확인해 주세요.<br />',
  'mypage.cancel_account.step2.body_title': '회원탈퇴 주의사항 안내',
  'mypage.cancel_account.step2.body_desc': '보유 자산이 있는 상태에서 회원 탈퇴를 진행하시면 잔고가 있는 경우에 모두 삭제 됩니다. <br />잔고를 반드시 확인하시고 출금을 완료하신 후에 회원 탈퇴를 진행 해 주시기 바랍니다. <br />회원 탈퇴 후에는 복구 할 수 없습니다.',
  'mypage.cancel_account.step3.body_title': '회원탈퇴 신청서 작성',
  'mypage.cancel_account.step3.body_desc': '회원탈퇴 신청시, 본인 확인을 위해 운전 면허증, 주민등록증, 여권 중 택 1을 하시고  앞면이 보이게 <br />본인 얼굴과 함께 사진촬영을 하고 메모와 함께 업로드해 주세요.<br />회원 탈퇴 신청 날짜, 연락처가 표시 되어야 하며, 얼굴이 선명하게 보이고 <br />모든 신분증 카드 세부 사항을 명확하게 읽을 수 있어야 합니다.',
  'mypage.cancel_account.step4.body_title': '회원탈퇴 신청 완료',
  'mypage.cancel_account.step4.body_desc': '회원 탈퇴 신청이 완료 되었습니다. <br />회원 탈퇴는 신청 접수 후 영업일 기준 약 2~3일 소요 예정입니다. <br />탈퇴가 완료 되면 거래소 로그인 시 기존 아이디와 패스워드로 접속이 되지 않으며, 아이디/패스워드 찾기를 하셔도 기존 아이디와 패스워드를 찾을 수 없습니다. ',
  'mypage.cancel_account.next': '다음',
  'mypage.cancel_account.go_to_write_form': '신청서 작성',
  'mypage.cancel_account.ok': '확인',
  'mypage.cancel_account.please_write_form_first': '신청서를 먼저 작성해주세요.',
};
